import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Banner, ExclusiveGroup } from '@app-model/oem-dealer';
import { FileUploaderService } from '@app-services/file-uploader.service';
import { FileUploadResult, OemDealerService } from '@app-services/oem-dealer.service';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { Toast, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { TargetBuyersLabel } from '@app/views/private/admin/model/advertisers';
import { AdminDealerFilter } from '@app/views/private/admin/model/admin-models';
import { PageControl } from '@app-model/page-control';
import { Params } from '@angular/router';

@Component({
  selector: 'app-banner-management',
  templateUrl: './banner-management.component.html',
  styleUrls: ['./banner-management.component.scss']
})
export class BannerManagementComponent implements OnInit {

  constructor(
    private oemDealerService: OemDealerService,
    private fileUploaderService: FileUploaderService,
    private toast: ToastrService
  ) { }

  banners: Banner[] = [];
  registering= false;

  imgUploader$: Observable<FileUploader>;

  imgUploadMessage: string;
  imgUploadError = false;

  imgMobileUploader$: Observable<FileUploader>;

  imgMobileUploadMessage: string;
  imgMobileUploadError = false;


  banner: Banner = new Banner();
  dealerFilterUrl = '';

  @ViewChild('registerer') registerer: ElementRef;

  @Input("personalization") personalizationId: string;

  loading = false;

  targetOptions = ['ALL', 'ONLY_COMPANIES', 'ONLY_COMPANIES_WITH_CNAE']

  scheduleTypeOptions = [ 'ABSOLUTE_DATE', 'CRON_RECURRENCE' ];
  scheduleTypeLabels = {
    'ABSOLUTE_DATE': 'Data Absoluta',
    'CRON_RECURRENCE': 'Recorrência (Cron)'
  };

  cronValidationError: String = null;

  startDateOnly: Date | null = null;
  startTimeOnly: string = '';
  endDateOnly: Date | null = null;
  endTimeOnly: string = '';

  ngOnInit() {
    this.initImageFileUploader();
    this.initImageMobileFileUploader();
  
    this.oemDealerService.getBanners(this.personalizationId).subscribe(resp => {
      if(resp){
        this.banners = resp.map(banner => this.mapBannerFromBackend(banner));
      } else {
        this.banners = [];
      }
    })
  }


  private mapBannerFromBackend(banner: any): Banner {
    const mappedBanner: Banner = {
      id: banner.id,
      name: banner.name,
      personalizationId: banner.personalizationId,
      disabled: banner.disabled,
      imageDesktop: banner.imageDesktop,
      imageMobile: banner.imageMobile,
      oemDealerId: banner.oemDealerId,
      urlDestination: banner.urlDestination,
      createdAt: banner.createdAt,
      target: banner.target,
      scheduleType: banner.scheduleType,
      startDate: banner.startDate,
      endDate: banner.endDate,
      status: banner.status,
      nextScheduledActivation: banner.nextScheduledActivation || banner.nextActivationDate || banner.nextActivationDate,
      dealerFilterUrl: banner.dealerFilterUrl
    };

    if (banner.activationCronExpression) {
      mappedBanner.activationCron = banner.activationCronExpression;
    } else if (banner.activationCron) {
      mappedBanner.activationCron = banner.activationCron;
    }

    if (banner.deactivationCronExpression) {
      mappedBanner.deactivationCron = banner.deactivationCronExpression;
    } else if (banner.deactivationCron) {
      mappedBanner.deactivationCron = banner.deactivationCron;
    }

    return mappedBanner;
  }

  registerOrUpdate(banner?: Banner){
    if(banner){
      this.banner = banner;
      this.dealerFilterUrl = banner.dealerFilterUrl || '';
      this.separateDateTime();
    }else{
      this.banner = new Banner();
      this.dealerFilterUrl = '';
      this.startDateOnly = null;
      this.startTimeOnly = '';
      this.endDateOnly = null;
      this.endTimeOnly = '';
    }

    this.registering = true;

    setTimeout(() => {
      this.scrollToRegistererElement();
    }, 0);
  }

  private separateDateTime(): void {
    if (this.banner.startDate) {
      const startDate = new Date(this.banner.startDate);
      this.startDateOnly = startDate;
      this.startTimeOnly = this.formatTime(startDate);
    } else {
      this.startDateOnly = null;
      this.startTimeOnly = '';
    }

    if (this.banner.endDate) {
      const endDate = new Date(this.banner.endDate);
      this.endDateOnly = endDate;
      this.endTimeOnly = this.formatTime(endDate);
    } else {
      this.endDateOnly = null;
      this.endTimeOnly = '';
    }
  }

  // Formata hora no formato HH:mm
  private formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  private combineDateTime(dateOnly: Date | null, timeOnly: string): Date | null {
    if (!dateOnly) {
      return null;
    }

    let hours = 0;
    let minutes = 0;

    if (timeOnly && timeOnly.trim() !== '') {
      const timeParts = timeOnly.split(':').map(Number);
      if (!isNaN(timeParts[0]) && !isNaN(timeParts[1])) {
        hours = timeParts[0];
        minutes = timeParts[1];
      }
    }

    const combined = new Date(dateOnly);
    combined.setHours(hours, minutes, 0, 0);
    return combined;
  }

  onStartDateChange(): void {
    this.banner.startDate = this.combineDateTime(this.startDateOnly, this.startTimeOnly);
  }

  onStartTimeChange(): void {
    this.startTimeOnly = this.formatTimeInput(this.startTimeOnly);
    this.banner.startDate = this.combineDateTime(this.startDateOnly, this.startTimeOnly);
  }
  onEndDateChange(): void {
    this.banner.endDate = this.combineDateTime(this.endDateOnly, this.endTimeOnly);
  }

  onEndTimeChange(): void {
    this.endTimeOnly = this.formatTimeInput(this.endTimeOnly);
    this.banner.endDate = this.combineDateTime(this.endDateOnly, this.endTimeOnly);
  }

  
  onCronChange(): void {}

  private formatTimeInput(value: string): string {
    if (!value) return '';
    
    const numbers = value.replace(/\D/g, '');
    
    const limited = numbers.substring(0, 4);
    
    if (limited.length <= 2) {
      return limited;
    } else if (limited.length === 3) {
      return limited.substring(0, 2) + ':' + limited.substring(2);
    } else {
      // Se tem 4 dígitos, formata como HH:mm
      return limited.substring(0, 2) + ':' + limited.substring(2, 4);
    }
  }

  private scrollToRegistererElement():void {
    this.registerer.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.banners, event.previousIndex, event.currentIndex);
    this.updateOrderBanners();
  }

  updateOrderBanners(){
    if(this.banners && this.banners.length > 1){
      this.oemDealerService.sortBanners(this.banners).subscribe(resp => {
        if(resp.success){
          this.toast.success("Ordenação atualizada com sucesso");
        }else{
          this.toast.error("Ocorreu um erro durante a ordenação");
        }
      })
    }
  }

  getTargetLabel(target: string): string {
    return TargetBuyersLabel.getLabel(target);
  }

  private async initImageFileUploader() {
    this.imgUploader$ = this.fileUploaderService.getInstance(
      {
        onBeforeUploadItem: (item: FileItem) => {
          this.imgUploadMessage = `Enviando arquivo ${item.file.name}`;
          this.imgUploadError = false;
        },
        onCompleteItem: (fileItem: FileItem, response: FileUploadResult) => {
          if (response.success) {
            this.imgUploadMessage = undefined;
            this.banner.imageDesktop = response.url
          } else {
            this.imgUploadError = true;
            this.imgUploadMessage = response.status;
          }
        },
      },
      {
        url: `${environment.api}/oemDealer/uploadBanner`,
        allowedMimeType: ["image/png", "image/jpg", "image/jpeg", "image/webp"],
        additionalParameter: {isMobile: false}
      }
    );
  }

  private async initImageMobileFileUploader() {
    this.imgMobileUploader$ = this.fileUploaderService.getInstance(
      {
        onBeforeUploadItem: (item: FileItem) => {
          this.imgMobileUploadMessage = `Enviando arquivo ${item.file.name}`;
          this.imgMobileUploadError = false;
        },
        onCompleteItem: (fileItem: FileItem, response: FileUploadResult) => {
          if (response.success) {
            this.imgMobileUploadMessage = undefined;
            this.banner.imageMobile = response.url;
          } else {
            this.imgMobileUploadError = true;
            this.imgMobileUploadMessage = response.status;
          }
        },
      },
      {
        url: `${environment.api}/oemDealer/uploadBanner`,
        allowedMimeType: ["image/png", "image/jpg", "image/jpeg", "image/webp"],
        additionalParameter: {isMobile: true}
      }
    );
  }

  removeImg(isDesktop: boolean): void{
    if(isDesktop){
      this.banner.imageDesktop = undefined;
    }else{
      this.banner.imageMobile = undefined;
    }
  }

  saveBanner(): void{
    this.loading = true;

    if(!this.banner){
      this.toast.error("Ocorreu um erro");
      return;
    }

    if(!this.banner.imageDesktop && this.banner.imageMobile){
      this.toast.error("Adicione os banners");
      return;
    }

    if(!this.banner.name){
      this.toast.error("Adicione um nome");
      return;
    }
    const isNew = this.banner.id == undefined;
    this.banner.personalizationId = this.personalizationId;

    if (this.banner.scheduleType === 'ABSOLUTE_DATE') {
      this.banner.startDate = this.combineDateTime(this.startDateOnly, this.startTimeOnly);
      this.banner.endDate = this.combineDateTime(this.endDateOnly, this.endTimeOnly);
      this.banner.activationCron = undefined;
      this.banner.deactivationCron = undefined;
    } else if (this.banner.scheduleType === 'CRON_RECURRENCE') {
      this.banner.startDate = undefined;
      this.banner.endDate = undefined;
    }

    if(this.banner.scheduleType && !this.validateSchedule()){
      this.toast.error("Erro na configuração de agendamento");
      this.loading = false;
      return; 
    }

    let dealerFilter = null;
    try {
      dealerFilter = this.getDealerFilterFromUrl();
    } catch (error) {
      this.toast.error("URL de filtro de compradores inválida.");
      this.loading = false;
      return;
    }

    this.banner.dealerFilterUrl = this.getDealerFilterUrl();
    const bannerToSend = this.prepareBannerPayload(dealerFilter);

    this.oemDealerService.saveBanner(bannerToSend).subscribe( resp => {
      if(resp.success){
        if(isNew){
          this.banner.id = resp.resourceId;
          this.banner.createdAt = new Date();
          this.banners.push(this.banner);
          this.toast.success("Banner cadastrado com sucesso!");
        } else {
          const index = this.banners.findIndex(b => b.id === this.banner.id);
          if(index !== -1){
            this.banners[index] = {...this.banner};
          }
          this.toast.success("Banner atualizado com sucesso!");
        }

        this.oemDealerService.getBanners(this.personalizationId).subscribe(bannersResp => {
          if(bannersResp){
            this.banners = bannersResp.map(banner => this.mapBannerFromBackend(banner));
          }
        });

        this.banner = new Banner();
        this.dealerFilterUrl = '';
        this.startDateOnly = null;
        this.startTimeOnly = '';
        this.endDateOnly = null;
        this.endTimeOnly = '';
        this.registering = false;
      }else{
        this.toast.error("Ocorreu um erro durante o cadastramento");
      }
      this.loading = false;
    })
  }

  
  private prepareBannerPayload(dealerFilter: AdminDealerFilter): any {
    const payload: any = {
      id: this.banner.id,
      name: this.banner.name,
      personalizationId: this.banner.personalizationId,
      disabled: this.banner.disabled,
      imageDesktop: this.banner.imageDesktop,
      imageMobile: this.banner.imageMobile,
      oemDealerId: this.banner.oemDealerId,
      urlDestination: this.banner.urlDestination,
      createdAt: this.banner.createdAt,
      target: this.banner.target,
      scheduleType: this.banner.scheduleType,
      dealerFilterUrl: this.banner.dealerFilterUrl,
      dealerFilter: dealerFilter
    };

    if (this.banner.scheduleType === 'ABSOLUTE_DATE') {
      payload.startDate = this.banner.startDate;
      payload.endDate = this.banner.endDate;
      
    } else if (this.banner.scheduleType === 'CRON_RECURRENCE') {
      payload.activationCronExpression = this.banner.activationCron;
      payload.deactivationCronExpression = this.banner.deactivationCron;
    }

    return payload;
  }

  private getDealerFilterFromUrl(): AdminDealerFilter {
    
    const url = this.getDealerFilterUrl();
    if(!url){
      return null;
    }

    const parsedUrl = new URL(url, window.location.origin);
    if(!parsedUrl.search){
      throw new Error("URL sem filtros");
    }

    const params: Params = {};
    parsedUrl.searchParams.forEach((value, key) => {
      params[key] = value;
    });

    const filter = new AdminDealerFilter();
    filter.pageControl = new PageControl();
    filter.pageControl.page = 0;
    filter.pageControl.sortField = 'score';
    filter.pageControl.sortDirection = 'DESC';
    filter.updateFromParamMap(params);

    return filter;
  }

  private getDealerFilterUrl(): string {
    return this.dealerFilterUrl && this.dealerFilterUrl.trim() !== ''
      ? this.dealerFilterUrl.trim()
      : null;
  }

  validateSchedule(): boolean {
    if(!this.banner.scheduleType){
      return true;
    }

    if (this.banner.scheduleType === 'ABSOLUTE_DATE') {
      return this.validateAbsoluteSchedule();
    }

    if(this.banner.scheduleType === 'CRON_RECURRENCE'){
      return this.validateCronSchedule();
    }

    return true;
  }

  private validateAbsoluteSchedule(): boolean{
    if(!this.startDateOnly){
      this.toast.error('Data de início é obrigatória para agendamento por data');
      return false;
    }

    if(!this.startTimeOnly || this.startTimeOnly.trim() === ''){
      this.toast.error('Horário de início é obrigatório para agendamento por data');
      return false;
    }

    if (!this.endDateOnly) {
      this.toast.error('Data de finalização é obrigatória para agendamento por data');
      return false;
    }

    if(!this.endTimeOnly || this.endTimeOnly.trim() === ''){
      this.toast.error('Horário de finalização é obrigatório para agendamento por data');
      return false;
    }

    if(!this.banner.startDate){
      this.toast.error('Data de início inválida');
      return false;
    }

    if (!this.banner.endDate) {
      this.toast.error('Data de finalização inválida');
      return false;
    }

    const now  = new Date();
    const startDate = new Date(this.banner.startDate);
    const endDate = new Date(this.banner.endDate);

    if(isNaN(startDate.getTime())){
      this.toast.error('Data de início inválida');
      return false;
    }
    if(isNaN(endDate.getTime())){
      this.toast.error('Data de finalização inválida');
      return false;
    }
    if(startDate >= endDate){
      this.toast.error('Data de início deve ser anterior à data de fim');
      return false;
    }

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() -1);
    if(startDate < oneYearAgo){
      this.toast.warning('Data de início muito antiga. Verifique se está correta.');
    }

    return true;
  }

  private validateCronSchedule(): boolean{
    if(!this.banner.activationCron || this.banner.activationCron.trim() === ''){
      this.toast.error('CronExpression ativação é obrigatória');
      return false;
    }

    if (!this.validateCronExpression(this.banner.activationCron)) {
      this.toast.error(`Cron de ativação inválida: ${this.cronValidationError}`);
     return false;
    }
    if(this.banner.deactivationCron && this.banner.deactivationCron.trim() !== ''){
       if (!this.validateCronExpression(this.banner.deactivationCron)) {
        this.toast.error(`Cron de desativação inválida: ${this.cronValidationError}`);
        return false;
      }
    }
    return true;
  }

  /**
   * Valida se uma cron expression está no formato correto
   * Formato esperado: minuto hora dia mês dia-da-semana (5 campos)
   * Exemplos válidos:
   * - "0 10 * * 5" (toda sexta às 10:00)
   * - "0 0 * * 0" (todo domingo à meia-noite)
   * - "30 14 1 * *" (dia 1 de cada mês às 14:30)
   */
  validateCronExpression(cron: string): boolean {
    if (!cron || typeof cron !== 'string') {
      this.cronValidationError = 'Cron expression não pode estar vazia';
      return false;
    }
    const trimmedCron = cron.trim();
    if (trimmedCron === '') {
      this.cronValidationError = 'Cron expression não pode estar vazia';
      return false;
    }
    const parts = trimmedCron.split(/\s+/);
    if (parts.length !== 5) {
      this.cronValidationError = 'Cron expression deve ter exatamente 5 campos separados por espaço: minuto hora dia mês dia-da-semana';
      return false;
    }

    const [minute, hour, day, month, dayOfWeek] = parts;

    if (!this.validateCronField(minute, 0, 59, 'minuto')) {
      return false;
    }
    if (!this.validateCronField(hour, 0, 23, 'hora')) {
      return false;
    }
    if (!this.validateCronField(day, 1, 31, 'dia do mês')) {
      return false;
    }
    if (!this.validateCronField(month, 1, 12, 'mês')) {
      return false;
    }
    if (!this.validateCronField(dayOfWeek, 0, 7, 'dia da semana')) {
      return false;
    }

    this.cronValidationError = null;
    return true;
  }

  
  private validateCronField(field: string, min: number, max: number, fieldName: string): boolean {
    if (!field || field.trim() === '') {
      this.cronValidationError = `${fieldName} não pode estar vazio`;
      return false;
    }

    if (field === '*') {
      return true;
    }


    if (field.includes('/')) {
      const stepParts = field.split('/');
      
      if (stepParts.length !== 2) {
        this.cronValidationError = `${fieldName} com step inválido. Use formato: */número ou intervalo/número`;
        return false;
      }

      const [range, stepStr] = stepParts;
      const step = parseInt(stepStr.trim(), 10);
      
      if (isNaN(step) || step <= 0) {
        this.cronValidationError = `${fieldName}: step deve ser um número positivo maior que zero`;
        return false;
      }

     
      if (range.trim() === '*') {
        return true;
      }

     
      if (range.includes('-')) {
        const [startStr, endStr] = range.split('-').map(s => s.trim());
        const start = parseInt(startStr, 10);
        const end = parseInt(endStr, 10);
        
        if (isNaN(start) || isNaN(end)) {
          this.cronValidationError = `${fieldName}: intervalo inválido no step`;
          return false;
        }
        
        if (start < min || end > max || start > end) {
          this.cronValidationError = `${fieldName}: intervalo no step deve estar entre ${min} e ${max}, e início <= fim`;
          return false;
        }
        
        return true;
      }

      const singleNum = parseInt(range.trim(), 10);
      if (isNaN(singleNum)) {
        this.cronValidationError = `${fieldName}: valor inválido antes do step`;
        return false;
      }
      
      if (singleNum < min || singleNum > max) {
        this.cronValidationError = `${fieldName}: valor antes do step deve estar entre ${min} e ${max}`;
        return false;
      }
      
      return true;
    }

    if (field.includes('-')) {
      const rangeParts = field.split('-');
      
      if (rangeParts.length !== 2) {
        this.cronValidationError = `${fieldName}: intervalo inválido. Use formato: início-fim`;
        return false;
      }

      const [startStr, endStr] = rangeParts.map(s => s.trim());
      const start = parseInt(startStr, 10);
      const end = parseInt(endStr, 10);
      
      if (isNaN(start) || isNaN(end)) {
        this.cronValidationError = `${fieldName}: valores do intervalo devem ser números`;
        return false;
      }
      
      if (start < min || end > max) {
        this.cronValidationError = `${fieldName}: intervalo deve estar entre ${min} e ${max}`;
        return false;
      }
      
      if (start > end) {
        this.cronValidationError = `${fieldName}: início do intervalo deve ser menor ou igual ao fim`;
        return false;
      }
      
      return true;
    }

    if (field.includes(',')) {
      const values = field.split(',').map(s => s.trim()).filter(s => s !== '');
      
      if (values.length === 0) {
        this.cronValidationError = `${fieldName}: lista não pode estar vazia`;
        return false;
      }

      for (const valueStr of values) {
        const num = parseInt(valueStr, 10);
        
        if (isNaN(num)) {
          this.cronValidationError = `${fieldName}: lista contém valor não numérico: ${valueStr}`;
          return false;
        }
        
        if (num < min || num > max) {
          this.cronValidationError = `${fieldName}: valor na lista (${num}) deve estar entre ${min} e ${max}`;
          return false;
        }
      }

      const uniqueValues = new Set(values);
      if (uniqueValues.size !== values.length) {
        this.cronValidationError = `${fieldName}: lista contém valores duplicados`;
        return false;
      }
      
      return true;
    }

    const num = parseInt(field.trim(), 10);
    
    if (isNaN(num)) {
      this.cronValidationError = `${fieldName}: valor inválido. Use número, *, intervalo (1-5), lista (1,3,5) ou step (*/5)`;
      return false;
    }
    
    if (num < min || num > max) {
      this.cronValidationError = `${fieldName}: valor (${num}) deve estar entre ${min} e ${max}`;
      return false;
    }
    
    return true;
  }

  getBannerStatus(banner: Banner): string {
    const now = new Date();
    if(banner.disabled){
      return 'Inativo';
    }
    if(!banner.scheduleType){
       return 'Ativo';
    }
  
    if(banner.scheduleType === 'ABSOLUTE_DATE'){
     if(!banner.startDate || !banner.endDate){
      return 'Configuração incompleta';
    }
    
    const startDate = new Date(banner.startDate);
    const endDate = new Date(banner.endDate);

    if(now < startDate){
      return 'Agendado para ativação';
    }

    if(now >= startDate && now < endDate){
      return 'Ativo (programado para fim)';
    }

    if(now >= endDate){
      return 'Expirado';
    }
  }

  if(banner.scheduleType === 'CRON_RECURRENCE'){
    if(banner.activationCron && banner.deactivationCron){
      return 'Cron configurado';
    }
    if(banner.activationCron){
      return 'Configurado para ativação';
    }
      return 'Configuração incompleta';
    }
  
   return 'Desconhecido';
  }

  
  getNextScheduledAction(banner: Banner): Date | null {
    if (!banner.scheduleType) {
      return null;
    }

    const now = new Date();

    if (banner.scheduleType === 'ABSOLUTE_DATE') {
      if (!banner.startDate) {
        return null;
      }

      const startDate = new Date(banner.startDate);
      
      if (now < startDate) {
        return startDate;
      }

      if (banner.endDate) {
        const endDate = new Date(banner.endDate);
        if (now < endDate) {
          return endDate;
        }
      }

      return null;
    }

   
    if (banner.scheduleType === 'CRON_RECURRENCE') {
      return banner.nextScheduledActivation || null;
    }

    return null;
  }

  onToggleBanner(event, banner: Banner){
    this.banner = banner;
    this.banner.disabled = !event;

    if (this.banner.disabled) {
      this.banner.scheduleType = undefined;
      this.banner.startDate = undefined;
      this.banner.endDate = undefined;
      this.banner.activationCron = undefined;
      this.banner.deactivationCron = undefined;
      this.startDateOnly = null;
      this.startTimeOnly = '';
      this.endDateOnly = null;
      this.endTimeOnly = '';
    }

    this.saveBanner();
  }

  removeBanner(banner: Banner){
    this.oemDealerService.removeBanner(banner.id).subscribe(resp => {
      if(resp.success){
        this.toast.success("Removido com sucesso!");
        
        this.banners = this.banners.filter(b => b.id != banner.id);
      }else{
        this.toast.error("Erro ao remover");
      }
    })
  }

}
